import React, { useMemo } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { NavigationLink } from '@components/Common';
import { useDialog } from 'core/hooks';
import { FairGameDialogs } from 'core/interfaces';
import { useFairGame } from '../../../hooks';

export const GameNavigation = () => {
  const { number, hash, salt, cards } = useFairGame();
  const { t } = useTranslation('baccarat');
  const { handleToggleDialog } = useDialog(FairGameDialogs.FAIR_GAME_DIALOG);

  const rand = useMemo(() => {
    return cards.playerHand.length
      ? `PLAYER: ${cards.playerHand.join(', ')}; BANKER: ${cards.bankHand.join(', ')}`
      : null;
  }, [cards]);

  return (
    <Container>
      <NavigationLink
        onClick={handleToggleDialog(FairGameDialogs.FAIR_GAME_DIALOG, {
          number,
          hash,
          salt,
          rand,
          ssh: '',
        })}
      >
        <div className="leading">
          <i className="icon-referrals" />
        </div>
        <div>
          <span>
            {t('Fair game')} #{number}
          </span>
        </div>
      </NavigationLink>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-flow: column;
  background: var(--color-dark-600);
`;
